/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tl_Zoom_QuartersInputs */

const en_tl_zoom_quarters = /** @type {(inputs: Tl_Zoom_QuartersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarters`)
};

const de_tl_zoom_quarters = /** @type {(inputs: Tl_Zoom_QuartersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartale`)
};

/**
* | output |
* | --- |
* | "Quarters" |
*
* @param {Tl_Zoom_QuartersInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tl_zoom_quarters = /** @type {((inputs?: Tl_Zoom_QuartersInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tl_Zoom_QuartersInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_tl_zoom_quarters(inputs)
	return en_tl_zoom_quarters(inputs)
});